import { render } from "./AuthenticateWhatsapp.vue?vue&type=template&id=59e50b39&scoped=true"
import script from "./AuthenticateWhatsapp.vue?vue&type=script&lang=js"
export * from "./AuthenticateWhatsapp.vue?vue&type=script&lang=js"

import "./AuthenticateWhatsapp.vue?vue&type=style&index=0&id=59e50b39&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e50b39"]])

export default __exports__